export enum LivePriceSymbolsKeyEnum {
  SIDE_WIDGET_WATCHLIST = 'sideWidgetWatchlist',
  SIDE_WIDGET_ORDERBOOK_SUMMARY = 'sideWidgetOrderbookSummary',
  COMPANY_HERO = 'companyHero',
  COMPANY_STREAM_ORDERBOOK = 'companyStreamOrderbook',
  TRENDING_STOCK = 'trendingStock',
  CATALOG = 'catalog',
  SECTOR = 'sector',
  WATCHLIST = 'watchlist',
  ORDERBOOK = 'orderbook',
  IHSG_WIDGET = 'ihsgWidget',
  SECURITIES_TRANSACTION = 'securitiesTransaction',
  TRADE_PAGE = 'tradePage',
  PORTFOLIO_DETAIL = 'portfolioDetail',
  ORDERLIST_DETAIL = 'orderlistDetail',
  FAST_ORDER = 'fastOrder',
}

export type LivePriceState = {
  symbols: { [key in LivePriceSymbolsKeyEnum]?: string[] };
};

export type LivePriceActions = {
  setLivePriceSymbols: (key: LivePriceSymbolsKeyEnum, value: string[]) => void;
};

export type LivePriceStore = LivePriceState & LivePriceActions;
